export const getToken = () => {
    return localStorage.getItem('token');
  };

export const getRole = () => {
  return localStorage.getItem('role');
};

export const getUserId = () => {
  return localStorage.getItem('id');
};

export const getCompanyId = () => {
  return localStorage.getItem('company_id');
};
  

export const removeToken = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('company_id');
  localStorage.removeItem('role');
  localStorage.removeItem('id');
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new Event('companyAuthChange'));
  }
};

export const getRefreshToken = () => {
  return localStorage.getItem('token');
};

const isBrowserOnLocalHost = () => {
  if (typeof window === 'undefined') {
    return false;
  }

  return ['localhost', '127.0.0.1', '::1'].includes(window.location.hostname);
};

const isLocalApiBase = (baseURL?: string) => {
  if (!baseURL) {
    return false;
  }

  try {
    const parsed = new URL(baseURL, typeof window !== 'undefined' ? window.location.origin : 'http://localhost');
    return ['localhost', '127.0.0.1', '::1'].includes(parsed.hostname);
  } catch {
    return /^https?:\/\/(localhost|127\.0\.0\.1|\[::1\])/i.test(baseURL);
  }
};

const getApiBaseURL = () => {
  const configuredBaseURL = process.env.REACT_APP_API_BASE_URL;
  if (configuredBaseURL && (isBrowserOnLocalHost() || !isLocalApiBase(configuredBaseURL))) {
    return configuredBaseURL;
  }

  return process.env.NODE_ENV === 'development'
    ? 'https://nexus.mbanet.com.pk/api/'
    : '/api/';
};

export const getAssetUrl = (path: string | null | undefined): string | null => {
  if (!path) return null;
  if (path.startsWith('http://') || path.startsWith('https://') || path.startsWith('blob:')) {
    return path;
  }
  const apiBase = getApiBaseURL().replace(/\/+$/, '');
  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  return `${apiBase}${cleanPath}`;
};
